import React, {useState} from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import TitleLight from '../../components/Text/TitleLight';
import i18n from '../../locales';
import MainStyles from '../../styles/MainStyles';
import './index.css'
import TitleBold from '../../components/Text/TitleBold';
import WhiteButton from '../../components/Buttons/WhiteButton';
import WhiteButtonOutline from '../../components/Buttons/WhiteButtonOutline';
import BannerHeader from '../../components/Headers/BannerHeader';
import {getVehicleData, persistVehicleData} from '../../services/Vehicles'
import Loading from '../../components/Loading';
import { getUserData } from '../login/LoginService';
import ModelDetails from '../../components/ModelDetails';
import REQUEST from '../../shared/http-request-util';

const _persisteVehicleAndUser = async (props, user, userVehicle, setDataSave) => {
  let body = {
    "user": {
      "document": user.document,
      "name": user.name,
      "phone": user.phone
    },
    "userVehicle": {
      "chassis": userVehicle.vin,
      "mileage": Number(userVehicle.mileage),
      "plate": userVehicle.plate
    }
  }

  setDataSave({isFetching: true});

  const vehicle = await getVehicleData(userVehicle.vin)
  const response = await persistVehicleData(body)
  if(response && response.user && response.userVehicle) {
    //GET GARAGE
    getUserData().then(userDB => {
      props.history.push({
        pathname: '/',
        state: {
          ...userDB,
          selectedVin: userVehicle.vin
        }
      })
      setDataSave({isFetching: false});
    })
  } else {
    console.log(response)
    // REQUEST()._handleErrorRedirect(response)
  }
}

const PageVehicleConfirm = (props) => {
  const { user, userVehicle } = props.location.state
  const [saveDate, setDataSave] = useState(null)

  return (
    <Container fluid="xl">
      <BannerHeader/>
      <Row className='vehicleconfirm-row' style={{ ...MainStyles.containerGradient }}>
        <Col>
          <Row>
            <Col sm={{ span: 6, offset: 1 }} md={{ span: 5, offset: 1 }}>
              <TitleLight
                text={i18n.t('vehicle_confirm.almost_there')}
                size={'bigger'}
                color={MainStyles.colors.white}
              />
              <br/>
              <TitleBold
                text={i18n.t('vehicle_confirm.is_yours')}
                size={'bigger'}
                color={MainStyles.colors.white}
              />
            </Col>
          </Row>
          <Row className='car-info' style={{marginTop: '7%'}}>
            <Col xs={{ span: 5}} sm={{ span: 5, offset: 1 }}>
              <TitleLight
                text={props.location.state.userVehicle.modelName}
                size={'bigger'}
                color={MainStyles.colors.white}
              />
              <br/>
              <ModelDetails
                selectedModel={props.location.state.userVehicle}
              />
              {/* <TitleLight
                text={props.location.state.userVehicle.versionName}
                size={'medium'}
                color={MainStyles.colors.white}
              />
              <br/>
              <TitleLight
                text={props.location.state.userVehicle.colorName}
                size={'medium'}
                color={MainStyles.colors.white}
              />
              <br/>
              <TitleLight
                text={props.location.state.userVehicle.modelYear}
                size={'medium'}
                color={MainStyles.colors.white}
              /> 
              <br/>
              <TitleLight
                text={props.location.state.userVehicle.plate}
                size={'medium'}
                color={MainStyles.colors.white}
              /> */}
            </Col>
            <Col xs={{ span: 7 }} sm={{ span: 5, offset: 1 }}>
              <Image 
                className='car-image'
                src={props.location.state.userVehicle.photo} 
              />
            </Col>
          </Row>
          <Row>
            <Col style={{ textAlign: 'center', marginTop: '5%' }} xs={{ span: 10, offset: 1 }} sm={{ span: 3, offset: 4 }}>
              <WhiteButtonOutline
                text={i18n.t('general.no_back')}
                isRounded={true}
                onClick={() => {
                  props.history.push('/vehicle-form')
                }}
              />
            </Col>
            <Col style={{ textAlign: 'center', marginTop: '5%' }} xs={{ span: 10, offset: 1 }} sm={{ span: 3, offset: 1 }}>
              <WhiteButton
                text={i18n.t('general.confirm')}
                isRounded={true}
                onClick={() => {
                  _persisteVehicleAndUser(props, user, userVehicle, setDataSave)
                }}
              />
            </Col>
          </Row>
        </Col>
      </Row>
      <Loading modalShow={saveDate && saveDate.isFetching}/>
    </Container>
  )
}

export default PageVehicleConfirm
